(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["memorra-product-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('memorra-personalizer')) {
 customElements.define('memorra-personalizer', class extends HTMLElement {
  connectedCallback() {
   this.scope = this.closest('product-info');
   this.input = this.querySelector('.EN-inp');
   if (!this.scope || !this.input) return;
   this.abort = new AbortController();
   this.input.addEventListener('input', () => { this.paint(); this.sync(); }, {signal: this.abort.signal});
   this.scope.addEventListener('submit', event => {
    if (event.target === this.form() || event.target.id === 'custom-breeze-proxy-form') {
     if (!this.validate()) { event.preventDefault(); event.stopImmediatePropagation(); }
     else this.sync();
    }
   }, {capture: true, signal: this.abort.signal});
   this.scope.addEventListener('click', event => {
    if (event.target.closest('.breeze-trigger,.shopify-payment-button')) {
     if (!this.validate()) { event.preventDefault(); event.stopImmediatePropagation(); }
     else this.sync();
    }
   }, {capture: true, signal: this.abort.signal});
   this.paint(); this.sync();
  }
  disconnectedCallback() { this.abort?.abort(); }
  form() { return this.scope.querySelector('product-form form'); }
  paint() {
   this.querySelector('.nr').textContent = this.input.value.trim() || this.dataset.default;
   this.querySelector('.EN-cc').textContent = `${this.input.value.length}/${this.input.maxLength}`;
   if (this.input.value.trim()) { this.querySelector('.EN-err').hidden = true; this.input.removeAttribute('aria-invalid'); }
  }
  validate() {
   const invalid = !this.input.value.trim();
   this.input.setAttribute('aria-invalid', String(invalid));
   this.querySelector('.EN-err').hidden = !invalid;
   if (invalid) { this.input.scrollIntoView({block: 'center', behavior: 'smooth'}); this.input.focus({preventScroll: true}); }
   return !invalid;
  }
  sync() {
   [this.form(), this.scope.querySelector('#custom-breeze-proxy-form')].filter(Boolean).forEach(form => {
    form.querySelectorAll('[data-memorra-property]').forEach(node => node.remove());
    const name = this.input.value.trim();
    if (!name) return;
    for (const [key, value] of [[`${this.dataset.kind} Name`, name], ['Font', 'Pristina']]) {
     const input = document.createElement('input');
     input.type = 'hidden'; input.name = `properties[${key}]`; input.value = value; input.dataset.memorraProperty = '';
     form.append(input);
    }
   });
  }
 });
}
if(!customElements.get('memorra-checkout')){
 customElements.define('memorra-checkout',class extends HTMLElement{
  connectedCallback(){
   this.scope=this.closest('product-info');if(!this.scope)return;
   this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.abort=new AbortController();
   this.scope.addEventListener('change',e=>{if(e.target.name==='id'||e.target.name==='quantity')this.update();},{signal:this.abort.signal});
   this.addEventListener('click',e=>{const btn=e.target.closest('.breeze-trigger');if(!btn)return;e.preventDefault();this.buy(btn,e);},{signal:this.abort.signal});this.update();
  }
  disconnectedCallback(){this.abort?.abort();}
  form(){return this.scope.querySelector('product-form form');}
  update(){
   const form=this.form(), id=form?.querySelector('[name=id]')?.value;
   const v=this.variants.find(v=>String(v.id)===id);this.variant=v;
   this.querySelectorAll('.breeze-trigger').forEach(b=>b.disabled=!v?.available);
   if(!v)return;
   const proxy=this.scope.querySelector('#custom-breeze-proxy-form');if(proxy){proxy.querySelector('[name=id]').value=v.id;let q=proxy.querySelector('[name=quantity]');if(!q){q=document.createElement('input');q.type='hidden';q.name='quantity';proxy.append(q);}q.value=form?.querySelector('[name=quantity]')?.value||'1';}
   const money=c=>new Intl.NumberFormat('en-IN',{style:'currency',currency:this.dataset.currency}).format(c/100);
   const price=this.querySelector('#summary-prod-price');if(price)price.textContent=money(v.price);
   const total=this.querySelector('#summary-total-price');if(total)total.textContent=money(v.price * Number(form?.querySelector('[name=quantity]')?.value||1));
   const saving=this.querySelector('#summary-savings-amount');if(saving)saving.textContent=this.dataset.saving.replace('[amount]',money(Math.max(0,(v.compare_at_price||v.price)-v.price)+41900));
  }
  async buy(button,event){
   if(this.busy)return;
   this.update();if(!this.variant?.available)return;
   const personalizer=this.scope.querySelector('memorra-personalizer');if(personalizer&&!personalizer.validate())return;personalizer?.sync();
   const error=this.querySelector('.memorra-checkout-error');error.hidden=true;
   const buttons=this.querySelectorAll('.breeze-trigger');this.busy=true;buttons.forEach(b=>b.disabled=true);
   try{
    const form=this.form(), data=new FormData(form);data.delete('sections');data.delete('sections_url');
    const fingerprint=new URLSearchParams(data).toString();
    if(this.pendingHandoff!==fingerprint){
     const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
     const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||'Please try again.');
     this.pendingHandoff=fingerprint;
    }
    await window.memorraCommerce.checkout(event);
    this.pendingHandoff=null;
   }catch(e){error.textContent=e.message||'Please try again.';error.hidden=false;}
   finally{this.busy=false;this.update();}
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
